































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import listMixins from '@/mixins/list'
import TaskApi from '@/api/task'
import RevisitApi from '@/api/revisit'

const columns = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '坐席',
		dataIndex: 'revisitorName',
		align: 'center',
		scopedSlots: { customRender: 'revisitor' },
	},
	{
		title: '联系对象',
		dataIndex: 'contactInfo',
		align: 'center',
		scopedSlots: { customRender: 'contactInfo' },
	},
	{
		title: '回访开始时间',
		dataIndex: 'revisitTime',
		align: 'center',
		scopedSlots: { customRender: 'revisitTime' },
	},
	{
		title: '回访状态',
		dataIndex: 'revisitStatus',
		align: 'center',
		scopedSlots: { customRender: 'revisitStatus' },
	},
	{
		title: '是否出院',
		dataIndex: 'outHospital',
		align: 'center',
		scopedSlots: { customRender: 'outHospital' },
	},
	{
		title: '重要标签',
		dataIndex: 'tagList',
		align: 'center',
		scopedSlots: { customRender: 'tagList' },
	},
	{
		title: '备注',
		dataIndex: 'remark',
		align: 'center',
	},
	{
		title: '操作',
		key: 'action',
		align: 'center',
		scopedSlots: { customRender: 'action' },
	},
]
@Component({})
export default class PendingTrack extends Mixins(listMixins) {
	private columns = columns
	private data: any = []
	private loading = false
	private adding = false

	public async getList() {
		this.loading = true
		const res = await TaskApi.getDetailPendingList({
			orderId: this.$route.params.orderId,
			pageSize: this.pageSize,
			pageNum: this.current,
		})

		const data = res.data
		this.total = data.count
		this.data = data.retList
		this.loading = false
	}

	private getContact(contactInfo: any) {
		let arr: string[] = []
		if (contactInfo.contactInjury === '1') {
			arr.push('伤者')
		}
		if (contactInfo.contactFamily === '1') {
			arr.push('伤者家属')
		}
		if (contactInfo.contactOwner === '1') {
			arr.push('车主')
		}
		return arr.join('、')
	}

	private addPendingTask() {
		this.adding = true
		RevisitApi.addTrackTask(this.$route.params.orderId)
			.then((res: any) => {
				this.$multiTab.close('/returnVisit/collectPendingInfo')
				this.$ls.set('pendingTaskId', res.data)
				this.$nextTick(() => {
					this.$multiTab.open('/returnVisit/collectPendingInfo')
				})
			})
			.finally(() => {
				this.adding = false
			})
	}

	public created() {
		this.getList()
	}
}
